import { RefreshCw } from 'lucide-react';
import { BrandOfflineHero } from './BrandLoaderHero';
import { BrandStatusPage } from './BrandStatusPage';

export interface OfflinePageProps {
  onRetry?: () => void;
}

/**
 * Full-viewport offline overlay. Dismisses when connectivity returns.
 */
export function OfflinePage({ onRetry }: OfflinePageProps): JSX.Element {
  return (
    <BrandStatusPage
      layout="viewport"
      tone="coral"
      bareHero
      hero={<BrandOfflineHero />}
      statusPill={
        <div className="mb-4 inline-flex items-center gap-1.5 rounded-full bg-coral-100 px-3 py-1.5 text-[11px] font-semibold uppercase tracking-[.16em] text-coral-600">
          <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-coral-500" />
          Offline
        </div>
      }
      title="You're offline."
      description="DentXE can't reach the network right now. Check your connection — we'll reconnect automatically when you're back online."
      primaryAction={{
        label: 'Retry connection',
        onClick: onRetry ?? (() => window.location.reload()),
        icon: RefreshCw,
        variant: 'primary',
      }}
      footer="Connection · DentXE"
    />
  );
}
